import React, {
	useState,
	useEffect,
	useMemo,
	useCallback,
} from 'react';
 import {
 	useSelector,
 	useDispatch,
} from 'react-redux';
import {
	actionSetMessage,
	actionResetMessages
} from 'components/messages/actions.js';
import {
	NoColumnFilter,
	//GlobalFilter,
	//DefaultColumnFilter,
	//fuzzyTextFilterFn
} from 'components/utils/tableFilters.js'
import { CheckAuth } from 'pages/auth/actions.js';
import Header from 'components/header.js';
import Footer from 'components/footer.js';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import OPWBreadcrumb from 'components/breadcrumb.js';
import Loading from 'components/loading.js'
import RptBtns from 'components/rptBtns.js';
//import Button from 'react-bootstrap/Button'

import { ClientSessionSelect } from 'components/clientSessionSelect/clientSessionSelect.js';
import { actionFetchSessionAvg, getDownloadFile } from './actions.js';
import { TableControl, TableStyles } from 'components/tableControl.js'
import {
	MovingAvgTimeSelect,
	//TimeSelectTypes
} from 'components/movingAvgTimeSelect/movingAvgTimeSelect.js';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
//import Alert from 'react-bootstrap/Alert';
//import { Link } from "react-router-dom";
import { saveAs } from 'file-saver';
import styled from 'styled-components';
//import useGTM from '@elgorditosalsero/react-gtm-hook';


const TITLE = 'Session data'
const showRecCount = 50	// default records to display
const BC = OPWBreadcrumb;

//:TODO: add totals on footer https://react-table.tanstack.com/docs/examples/footers


// this is specifically for this table and overwrites TableStyles.
const Session2TableStyles = styled.div`
	th#visId input {max-width: 4rem;}
	th#eid input {max-width: 8rem;}
	tr {
		td {
			padding-left: 0.2rem;
			padding-right: 0.2rem;
		}
	}
`

const ParamPanel = (props) => {
	const {handleChange, timebase, loading, handleDownload, downloading} = props;
	const cols = {lhs:4, rhs:8}
	const controlStyle = {width: '15em'}

	// const { sendDataToGTM } = useGTM()
	// const testTag = () =>{
	// 	console.log('running test tag');
	// 	sendDataToGTM({ event: 'testButtonOnSessionData2', value: 'clicked' })
	// }
	return (
		<Card
			className={'no-print'}
			body
		>
			<Card.Title>{TITLE}</Card.Title>
			<Card.Body>
				{/* <Button
				onClick={()=>testTag()}
				>Test tags</Button> */}
			<Row>
				<Col sm={ 4 }>
					<ClientSessionSelect
						layout = { 'select' }
						hideSessionSelect = { false }
						handleBeforeSessionChange = { ()=>{} }
						lock = { false }
					/>
				</Col>
				<Col sm={ 4 }>
					<MovingAvgTimeSelect
						cols = { cols }
						size = {'sm'}
						controlStyle = { controlStyle }
						required = {true}
						handleChange = {(evt) => handleChange(evt)}
						value = { timebase || '' }
					/>
					<div className = {'w-50 mx-auto'}><Loading loading = { loading } /></div>
				</Col>
				<Col sm={ 4 }>
					<div className={'text-right report-buttons'}>
						<RptBtns
							enablePrint = { true }
							enableHelp = { true }
							enableDownload = { true }
							/*handleDownload = {() => { alert('Optiweigh feature coming soon - thanks for your patience.') }}*/
							handleDownload = { () => handleDownload() }
							downloading = { downloading }
						/>
					</div>
					<p className="dt-leftMargin note">Click column head ▽ to sort data.</p>
				</Col>
			</Row>
			</Card.Body>
		</Card>
	)
}

const NoData = () => (
	<h1>No data</h1>
)

// pagination
//https://medium.com/better-programming/an-introduction-to-react-table-6ebd34d8059e
export const SessionData2 = (props) => {
	/**
	 *
	 *
	 *
	 */

	//const { sendDataToGTM } = useGTM()
	const [data, setData] = useState([]);//	local data for graph or report
	const [loading, setLoading] = useState(false);
	const [downloading, setDownloading] = useState(false);
	const [timebase, setTimebase] = useState('MA_30')
	const session = useSelector(state => state.session);
	//const sessionId = useSelector(state => state.sessionId);
	//const sessionIds = useSelector(state => state.sessionIds);
	const dispatch = useDispatch()

	const handleTimebaseChange = (evt) =>{
		//console.log('handleTimebaseChange', evt.target)
		//sendDataToGTM({ event: 'time base changed', value: evt.target.value })
		setTimebase(evt.target.value);
	}

	const handleDownload = async () => {
		setDownloading(true);
		const { data } = await getDownloadFile(session.SessionID, timebase)
		await saveAs(data, 'session_data.csv')
		setDownloading(false);
	}

	useEffect(() => {
		document.title = TITLE
		//sendDataToGTM({ event: 'pageLoad', value: 'sessionData2' })
	//},[sendDataToGTM])
	},[])

	const showMessage = useCallback(
		(data) => dispatch(actionSetMessage(data)),
		[dispatch]
	)

	useEffect(() => {
		async function fetchData() {
			dispatch(actionResetMessages())
			const resp = await actionFetchSessionAvg(session.SessionID, timebase, showMessage, setLoading)
			setData(resp)
		}
		if (session.SessionID > 0){
			setLoading(true)
			fetchData();
		}
	},[session, timebase, showMessage, setLoading, dispatch])

	//console.log('data', data)
	if (data === undefined){
		return (
			<Template
				loading = { loading }
				handleTimebaseChange = { handleTimebaseChange }
				timebase = { timebase }
				handleDownload = { handleDownload }
				downloading = { downloading }
			>
				<NoData />
			</Template>
		)
	} else {
		return (
			<Template
				loading = { loading }
				handleTimebaseChange = { handleTimebaseChange }
				timebase = { timebase }
				handleDownload = { handleDownload }
				downloading = { downloading }
			>
				<h2 className={'only-print'}>Optiweigh - Session data</h2>
				{/* <pre>{ JSON.stringify(data) }</pre> */}
				<SessionDataTable
					data = { data }
					//session = { session || '' }
					timebase = { timebase }
				/>
			</Template>
		)
	}
}

const Template = (props) => (
	<div>
		<Header><BC trail='[["Home", "/"], ["reports", "/"], ["session data", ""]]' /></Header>
		<Container fluid className="body">
			<CheckAuth groupName = { 'user' }/>
			<ParamPanel
				handleChange = { props.handleTimebaseChange }
				timebase = { props.timebase }
				loading = { props.loading }
				handleDownload = { props.handleDownload }
				downloading = { props.downloading }
			/>
			{ props.children }
		</Container>
		<Container fluid>
			<Row>
				<Col sm='12'>
					<Footer />
				</Col>
			</Row>
		</Container>
	</div>
)


function SessionDataTable(props) {
	const {
		data,
		//timebase
	} = props
	//console.log('props', props)

	// var nSum = 0;
	// if (data.length >0) {
	// 	for (let i = 0; i < data.length; i++) {
	// 		//marketValSum += accountData[i].marketValue;
	// 		//cashSum += accountData[i].cash;
	// 		nSum += data[i].n
    // 	}
	// }

	const columns = useMemo(() => [
		{
			//Header: 'Animal (every animal ever recorded in this session)',
			Header: 'Animal',
			Footer: '',
			columns: [
				{
					Header: 'RFID',
					Footer: 'Average',
					accessor: 'eid',
					sortType: 'basic',
					style: {textAlign: 'center',},

				},
				{
					Header: 'Visual ID',
					Footer: '',
					accessor: 'visId',
					sortType: 'basic',
					//filter: 'fuzzyText',
					//Filter: NoColumnFilter,
					style: {textAlign: 'center',},

				},
			],
		},
		{
			//Header: 'Session averages',
			Header: 'Session data',
			Footer: '',
			columns: [
				{
					Header: "Average Weight [kg]",
					Footer: info => {
						const avgObj = React.useMemo(
							() => info.rows.reduce((dataObj, row) => {
									if (isNaN(row.values.avWt)){//only include numeric in calcs
										return dataObj;
									} else {
										return {sum: row.values.avWt + dataObj.sum, count: dataObj.count+1}
									}
								}, {sum: 0, count: 0}),
							[info.rows]
						)
						const avg = (avgObj.count > 0) ? parseFloat(Math.round(avgObj.sum/avgObj.count)).toLocaleString('en'): 'n/a';
						return <>{ avg }</>
					},
					accessor: 'avWt',
					Filter: NoColumnFilter,
					//Filter: SelectColumnFilter,
					//filter: 'includes',
					style: {textAlign: 'right',},
				},
				{
					Header: "Current Weight [kg]",
					Footer: info => {
						const avgObj = React.useMemo(
							() =>
								info.rows.reduce((dataObj, row) => {
									if (isNaN(row.values.fiveAvWt)){//only include numeric in calcs
										return dataObj;
									} else {
										return {sum: Number(row.values.fiveAvWt) + dataObj.sum, count: dataObj.count+1}
									}
								}, {sum: 0, count: 0}),
							[info.rows]
						)
						const avg = (avgObj.count > 0) ? parseFloat(Math.round(avgObj.sum/avgObj.count)).toLocaleString('en'): 'n/a';
						return <>{ avg }</>
					},
					accessor: 'fiveAvWt',
					Filter: NoColumnFilter,
					//Filter: SelectColumnFilter,
					//filter: 'includes',
					style: {textAlign: 'right',},
				},
				{
					Header: 'Count of Weights',
					//Footer: `Total: ${nSum}`,
					// Footer: info => {
					// 	// Only calculate total visits if rows change
					// 	const total = React.useMemo(
					// 		() =>
					// 			info.rows.reduce((sum, row) =>
					// 				//console.log('debug row', row)
					// 				row.values.n + sum, 0

					// 		),
					// 	  [info.rows]
					// 	)
					// 	return <>{ parseFloat(total).toLocaleString('en') }</>
					// },

					Footer: info => {
						const avgObj = React.useMemo(
							() =>
								info.rows.reduce((dataObj, row) => {
									if (isNaN(row.values.n)){//only include numeric in calcs
										return dataObj;
									} else {
										return {sum: parseFloat(row.values.n) + dataObj.sum, count: dataObj.count+1}
									}
								}, {sum: 0, count: 0}),
							[info.rows]
						)
						const avg = (avgObj.count > 0) ? parseFloat(Math.round(avgObj.sum/avgObj.count)).toLocaleString('en'): 'n/a';
						return <>{ avg }</>
					},
					//https://github.com/tannerlinsley/react-table/blob/master/examples/footers/src/App.js
					//https://react-table.tanstack.com/docs/examples/footers
					accessor: 'n',
					sortType: 'basic',
					style: {textAlign: 'right',},
					Filter: NoColumnFilter,
					//headerStyle: {textAlign: 'right'},
					//Filter: SelectColumnFilter,
					//filter: 'includes',
					//caption: 'Average daily gain [kg]'
				}
			],
		},
		{
			//Header: 'Average Daily Gain in Past ' + TimeSelectTypes[timebase],
			Header: 'Average Daily Gain',
			Footer: '',
			columns: [
				{
					Header: 'ADG [kg/day]',
					Footer: info => {
						const avgObj = React.useMemo(
							() =>
								info.rows.reduce((dataObj, row) => {
									if (isNaN(row.values.ADG)){//only include numeric in calcs
										return dataObj;
									} else {
										return {sum: Number(row.values.ADG) + dataObj.sum, count: dataObj.count+1}
									}
								}, {sum: 0, count: 0}),
							[info.rows]
						)
						const avgWorking = Math.round(avgObj.sum/avgObj.count*10)/10;// round to 1 place as it is ADG
						const avg = (avgObj.count > 0) ? Number(avgWorking).toLocaleString('en'): 'n/a';
						return <>{ avg }</>
					  },
					accessor: 'ADG',
					Filter: NoColumnFilter,
					//Filter: SelectColumnFilter,
					//filter: 'includes',
					style: {textAlign: 'right',},
				},
				{
					Header: 'Gain duration [days]',
					//Footer: '',
					accessor: 'Days',
					Filter: NoColumnFilter,
					//Filter: SelectColumnFilter,
					//filter: 'includes',
					style: {textAlign: 'right',},
					Footer: info => {
						const avgObj = React.useMemo(
							() =>
								info.rows.reduce((dataObj, row) => {
									if (isNaN(row.values.Days) || isNaN(row.values.ADG)){//only include if there is both a number of days and an adg for that animal
										return dataObj;
									} else {
										return {sum: parseInt(row.values.Days) + dataObj.sum, count: dataObj.count+1}
									}
								}, {sum: 0, count: 0}),
							[info.rows]
						)
						const avg = (avgObj.count > 0) ? parseFloat(Math.round(avgObj.sum/avgObj.count)).toLocaleString('en'): 'n/a';
						return <>{ avg }</>
					  },
				},
			],
		},
	],[]
	)
	return (
		<TableStyles className="sessionDataTable">
			<Session2TableStyles>
				<TableControl
					columns = { columns }
					data = { data }
					showRecCount = { showRecCount }
					NoDataComponent={ NoData }
					//selectSet={(id) => selectSet(id)}
				/>
			</Session2TableStyles>
		</TableStyles>
	)
}

//export default SessionDataTable